// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let React = require("react");
let Redirect = require("../../reason/common/Redirect.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedDisplayOnlyMemberPhotoForm = require("./UnifiedDisplayOnlyMemberPhotoForm.bs.js");
let UnifiedDisplayOnlyMemberInformationForm = require("./UnifiedDisplayOnlyMemberInformationForm.bs.js");
let UnifiedEditDisplayOnlyMemberQuery_graphql = require("../../__generated__/UnifiedEditDisplayOnlyMemberQuery_graphql.bs.js");
let UnifiedDisplayOnlyMemberSocialAccountsForm = require("./UnifiedDisplayOnlyMemberSocialAccountsForm.bs.js");
let UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql = require("../../__generated__/UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.bs.js");
let UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql = require("../../__generated__/UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.bs.js");

let convertVariables = UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedEditDisplayOnlyMemberRemoveDisplayMemberMutation_graphql.node, convertResponse, convertWrapRawResponse);

let RemoveDisplayMemberMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useRemoveDisplayMember() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.removeUnifiedDisplayMember;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let convertFragment = UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedEditDisplayOnlyMember$Page(props) {
  let member = RescriptRelay_Fragment.useFragment(UnifiedEditDisplayOnlyMember_displayOnlyMember_graphql.node, convertFragment, props.member);
  let match = useRemoveDisplayMember();
  let saving = match[1];
  let save = match[0];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let match$2 = React.useState(() => false);
  let setConfirming = match$2[1];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: `Edit ` + member.displayName + `'s profile`,
        rootName: "Members",
        rootUrl: "/account/account_profile/members",
        url: `/account/account_profile/members/` + member.nodeId + `/edit`
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Member information",
            className: "text-lg font-semibold leading-7 text-gray-900"
          }),
          JsxRuntime.jsx(UnifiedDisplayOnlyMemberInformationForm.make, {
            member: member.fragmentRefs
          })
        ],
        className: "space-y-4"
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Profile picture",
            className: "text-lg font-semibold leading-7 text-gray-900"
          }),
          JsxRuntime.jsx(UnifiedDisplayOnlyMemberPhotoForm.make, {
            member: member.fragmentRefs
          })
        ],
        className: "space-y-4 border-t border-zinc-200 pt-8"
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Social accounts",
            className: "text-lg font-semibold leading-7 text-gray-900"
          }),
          JsxRuntime.jsx(UnifiedDisplayOnlyMemberSocialAccountsForm.make, {
            member: member.fragmentRefs
          })
        ],
        className: "space-y-4 border-t border-zinc-200 pt-8"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: "/account/account_profile/members",
          children: "Back to Members"
        })
      }),
      JsxRuntime.jsx("section", {
        children: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
          onClick: param => setConfirming(param => true),
          disabled: saving,
          children: "Remove Display-only member"
        }),
        className: "border-t border-zinc-200 pt-8"
      }),
      JsxRuntime.jsx(ConfirmDialog.make, {
        title: `Remove ` + member.displayName + `?`,
        ariaLabel: `Confirm removal of ` + member.displayName,
        body: JsxRuntime.jsx("p", {
          children: "This removes this display-only member from the team profile. This cannot be undone."
        }),
        isOpen: match$2[0],
        onCancel: () => setConfirming(param => false),
        cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          onClick: param => setConfirming(param => false),
          disabled: saving,
          children: "Cancel"
        }),
        confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
          onClick: param => save({
            memberNodeId: member.nodeId
          }, () => {
            addMessage(SystemMessages.Message.make(undefined, "success", "The display-only member was removed successfully", 5000, undefined, undefined));
            Next.SingletonRouter.replace("/account/account_profile/members", undefined, undefined);
          }, param => setConfirming(param => false)),
          disabled: saving,
          children: "Remove member"
        })
      }),
      match[2]
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let Page = {
  Fragment: Fragment,
  make: UnifiedEditDisplayOnlyMember$Page
};

let convertVariables$1 = UnifiedEditDisplayOnlyMemberQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedEditDisplayOnlyMemberQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedEditDisplayOnlyMemberQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedEditDisplayOnlyMemberQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedEditDisplayOnlyMemberQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedEditDisplayOnlyMemberQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedEditDisplayOnlyMemberQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedEditDisplayOnlyMemberQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedEditDisplayOnlyMemberQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedEditDisplayOnlyMember(props) {
  let memberId = props.memberId;
  let match = use$2({
    memberId: memberId
  }, undefined, undefined, undefined);
  let node = match.node;
  if (node !== undefined) {
    if (node.__typename === "DisplayOnlyMember") {
      return JsxRuntime.jsx(UnifiedEditDisplayOnlyMember$Page, {
        member: node.fragmentRefs
      }, memberId);
    } else {
      return UnselectedUnionMemberError.raise(`Unselected profile member: ` + node._0);
    }
  } else {
    return JsxRuntime.jsx(Redirect.make, {
      path: "/account/account_profile/members"
    });
  }
}

let make = UnifiedEditDisplayOnlyMember;

exports.RemoveDisplayMemberMutation = RemoveDisplayMemberMutation;
exports.useRemoveDisplayMember = useRemoveDisplayMember;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
